import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import throttle from 'lodash/throttle';

import LoginLink from 'core/modules/LoginLink/LoginLink';

import { selectActiveMQ } from 'core/modules/MediaQueries/selectors';
import { selectUserIsIdentified } from 'core/selectors/user';
import { selectPageName } from 'core/selectors/app';

import { triggerStickyCtaBarIsViewed } from './actions';

import config from './configs';

import './StickyCtaBar.scss';

function StickyCtaBar() {
  const {
    topOffsetSelector, bottomOffsetSelector, urlLink, urlTitle, useRegistrationLink,
    useStickyBehaviorOnMediaQueriesOnly, viewOptions,
  } = config;
  const { title, buttonLanguage } = viewOptions;

  const dispatch = useDispatch();
  const activeMQ = useSelector(selectActiveMQ);
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const pageName = useSelector(selectPageName);
  const isHomePage = pageName === 'h';
  const stickyCtaBarElement = useRef();

  useEffect(() => {
    if (!userIsIdentified && isHomePage) {
      dispatch(triggerStickyCtaBarIsViewed());
    }
  }, [isHomePage, userIsIdentified, dispatch]);

  const checkShouldDisplayStickyCtaBarOnScroll = () => {
    const topOffsetContainer = document.querySelector(topOffsetSelector);
    const bottomOffsetContainer = document.querySelector(bottomOffsetSelector);

    const isTopOffsetContainerOutOfView = topOffsetContainer?.getBoundingClientRect().bottom < 0;
    const isBottomOffsetContainerOutOfView = bottomOffsetContainer?.getBoundingClientRect().top >= window.innerHeight;

    return isTopOffsetContainerOutOfView && isBottomOffsetContainerOutOfView;
  };

  const handleStickyBehavior = () => {
    const shouldDisplayStickyCtaBarOnScroll = checkShouldDisplayStickyCtaBarOnScroll();
    const shouldDisplayStickyCtaBarOnCurrentMediaQuery = useStickyBehaviorOnMediaQueriesOnly.includes(activeMQ);

    const shouldDisplayStickyCtaBar =
      shouldDisplayStickyCtaBarOnScroll && shouldDisplayStickyCtaBarOnCurrentMediaQuery;

    stickyCtaBarElement.current.classList.toggle('mn_sticky', shouldDisplayStickyCtaBar);
  };

  useEffect(() => {
    const throttledHandleStickyBehavior = throttle(handleStickyBehavior, 10);

    window.addEventListener('scroll', throttledHandleStickyBehavior);
    window.addEventListener('resize', throttledHandleStickyBehavior);

    return () => {
      window.removeEventListener('scroll', throttledHandleStickyBehavior);
      window.removeEventListener('resize', throttledHandleStickyBehavior);
    };
  }, [activeMQ]);

  return (
    <div className="mn_stickyCtaBarWrap">
      <div className="mn_stickyCtaBar" ref={stickyCtaBarElement}>
        <div className="mn_contentWrap ">
          <div className="mn_stickyCtaBarContent">
            <h3>{title}</h3>
            <LoginLink
              url={urlLink}
              useRegistrationLink={useRegistrationLink}
              className="mn_button mn_buttonInverted"
              title={urlTitle}
            >
              {buttonLanguage}
            </LoginLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StickyCtaBar;
